// src/modules/app-views/account/pages/Init/modals/ChangePasswordModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { LockOutlined, CheckCircleOutlined } from '@ant-design/icons';
import SimplePassword from 'components/SimpleComponents/SimplePassword';
import appService from 'services/appService';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const NewPasswordStepContent = () => (
  <>
    <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
      {translateX('enter_new_password_description')}
    </Text>
    <SimplePassword
      name="newPassword"
      label="new_password"
      required
      autoComplete="new-password"
      prefix={<LockOutlined className="text-primary" />}
      minLength={6}
    />
    <SimplePassword
      name="confirmPassword"
      label="confirm_new_password"
      required
      autoComplete="new-password"
      prefix={<CheckCircleOutlined className="text-primary" />}
      minLength={6}
    />
  </>
);

// *******************************************************************************
// HELPERS
// *******************************************************************************
const validateNewPassword = async ({ form, goFocus }) => {
  const newPassword = form?.getFieldValue('newPassword');
  const confirmPassword = form?.getFieldValue('confirmPassword');

  if (!newPassword || newPassword.trim() === '') {
    await appService.message({ flag: 'w', text: 'password_is_required' });
    goFocus?.('newPassword', true);
    return false;
  }

  if (newPassword.length < 6) {
    await appService.message({ flag: 'w', text: 'password_min_length' });
    goFocus?.('newPassword', true);
    return false;
  }

  if (!confirmPassword || confirmPassword.trim() === '') {
    await appService.message({ flag: 'w', text: 'confirm_password_required' });
    goFocus?.('confirmPassword', true);
    return false;
  }

  if (newPassword !== confirmPassword) {
    await appService.message({ flag: 'w', text: 'passwords_do_not_match' });
    goFocus?.('confirmPassword', true);
    return false;
  }

  return true; // Allow finish
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const newPasswordStep = () => ({
  stepTitle: 'new_password',
  stepTooltip: 'enter_new_password',
  content: () => <NewPasswordStepContent />,
  validationFields: ['newPassword', 'confirmPassword'],
  nextButtonText: 'change_password',
  nextButtonIcon: <LockOutlined />,
  isConfirmStep: true,
  onNext: async ({ form, goFocus }) => validateNewPassword({ form, goFocus }),
  onEnter: ({ goFocus }) => {
    // Focus on the new password field when entering this step
    setTimeout(() => goFocus?.('newPassword'), 100);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default newPasswordStep;
